import { Component, HostListener, ViewChild, inject } from '@angular/core';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { CommandPaletteComponent } from '../../components/command-palette/command-palette.component';
import { CommandPaletteService } from '../../services/command-palette.service';

@Component({
  selector: 'app-sidebar-layout',
  imports: [
    SidebarComponent,
    RouterModule,
    HeaderComponent,
    CommandPaletteComponent,
  ],
  templateUrl: './sidebar-layout.component.html',
  styleUrl: './sidebar-layout.component.scss',
})
export class SidebarLayoutComponent {
  private readonly commandPaletteService = inject(CommandPaletteService);

  @ViewChild(CommandPaletteComponent)
  commandPaletteComponent?: CommandPaletteComponent;

  @HostListener('document:keydown', ['$event'])
  onDocumentKeydown(event: KeyboardEvent) {
    if (!this.isHotkeyTrigger(event) || !this.isDesktopSidebarVisible()) {
      return;
    }

    event.preventDefault();
    this.commandPaletteService.toggle();
    if (this.commandPaletteService.isOpen) {
      this.commandPaletteComponent?.focusInput();
    }
  }

  private isHotkeyTrigger(event: KeyboardEvent): boolean {
    const isModifierPressed = event.metaKey || event.ctrlKey;
    return isModifierPressed && event.key.toLowerCase() === 'k';
  }

  private isDesktopSidebarVisible(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }

    return window.matchMedia('(min-width: 768px)').matches;
  }
}
